import React, {useEffect, useState} from "react";
import {Row} from "react-bootstrap";
import common from "../../../translations/it/common.json";
import Input from "../../../components/inputText/Input";
import Button from "../../../components/Button/Button";
import Table from "../../../components/table/Table";
import {useHistory} from "react-router";
import ModificaUtente from "../InserisciModificaUtente/ModificaUtente";
import Spinner from "../../../components/spinner/Spinner";
import ApmsService from "../../../services/ApmsService";
import Utils from "../../../utils/Utils";
import style from "../../sportelli/ElencoSportelli.module.css";


function RicercaUtenti(props) {

    const [state, setState] = useState({cognome: "", nome: "", ente: ""})
    const [flagTableCercaUtenti, setFlagTableCercaUtenti] = useState(false)
    const [modalBodyModifica, setModalBodyModifica] = useState(null)
    const history = useHistory()
    const [pagination, setPagination] = useState({size: 5, page: 0, sort: "nome", order: "asc"})
    const [showSpinner, setShowSpinner] = useState(false)
    const [cols, setCols] = useState([])
    const [rows, setRows] = useState([])
    useEffect(() => {
        Utils.createColsElencoUtenti(setShowSpinner, setCols, onClickButtonModifica, style.buttonTable)
    }, [])

    useEffect(() => {
        Utils.createColsElencoUtenti(setShowSpinner, setCols, onClickButtonModifica, style.buttonTable)
    }, [rows])

    useEffect(() => {
        ricercaUtenti()
    }, [pagination.page, pagination.sort, pagination.order])

    function onChange(id, value) {
        let newState = {...state}
        newState[id] = value
        setState(newState)
    }

    function ricercaUtenti(flagRicerca) {
        setShowSpinner(true)
        let params = {
            applicazione: "RAF",
            size: pagination.size,
            page: pagination.page,
            sort: pagination.sort,
            order: pagination.order.toLowerCase(),
            nome: state.nome.toUpperCase(),
            cognome: state.cognome.toUpperCase()
        }
        if (state.ente) {
            params.profilo = "*%3BRAF-ente%3B%5Ba-zA-Z( )0-9%5D*" + state.ente.toUpperCase()
        }
        ApmsService.ricercaUtenti(params).then(res => {
            let newPagination = {...pagination}
            newPagination.totalPages = res.data.totalElements <= pagination.size ? 1 : Math.floor(res.data.totalElements / pagination.size)
            newPagination.totalElements = res.data.totalElements
            let listaUtenti = Utils.createListaUtentiFromApms(res.data.elementi)
            setRows(listaUtenti)
            setPagination(newPagination)
            history.push({utenti: listaUtenti})
            setShowSpinner(false)
            if (flagRicerca) {
                setFlagTableCercaUtenti(true)
            }
        }).catch(reason => {
            console.log("Errore Operation GET Utenti: " + reason)
            setShowSpinner(false)
        })

    }


    function onClickButtonModifica(id) {
        history.location.utenti.forEach(utente => {
            if (utente.id === id) {
                history.push({utenti: history.location.utenti, vecchioRuolo: utente.ruolo})
                let utenteModifica = {...utente}
                let enteModifica = utenteModifica.ente.split("|")
                let enteSelect = []
                enteModifica.forEach(ente => {
                    let enteSplit = ente.split(";")
                    enteSelect.push(enteSplit[3])
                })
                utenteModifica.ente = enteSelect
                setModalBodyModifica(<ModificaUtente state={utenteModifica} getUtenti={props.getUtenti}/>)
            }
        })
        document.getElementById("modificaUtenteRicerca").click();
    }

    function onClickCercaUtenti() {
        ricercaUtenti(true)
    }

    return (
        <div className={" pl-4 "} style={{marginTop: "50px"}}>
            <Spinner show={showSpinner}/>
            <div className={"row"}>
                <div className="col-10">
                    <p style={{fontWeight: "bold", fontSize: "20px"}}>{common.RicercaUtente.titolo}</p>
                </div>
                <div className="col-2">
                    <p style={{fontWeight: "bold", fontSize: "16px", color: "red"}}>Campo obbligatorio*</p>
                </div>
            </div>
            <Row>
                <div className={"col-10"}>
                    <Row>
                        <div className={"col-3"}>
                            <span style={{fontWeight: "bold"}}>Cognome<span style={{fontWeight: "bold", fontSize: "14px", color:"red"}}>*</span></span>
                            <Input placeholder={"Cognome"} id={"cognome"}
                                   onChange={(event) => onChange(event.target.id, event.target.value)}
                                   value={state.cognome ? state.cognome : ""}/>
                        </div>
                        <div className={"col-3"}>
                            <span style={{fontWeight: "bold"}}>Nome<span style={{fontWeight: "bold", fontSize: "14px", color:"red"}}>*</span></span>
                            <Input placeholder={"Nome"} id={"nome"}
                                   onChange={(event) => onChange(event.target.id, event.target.value)}
                                   value={state.nome ? state.nome : ""}/>
                        </div>
                        <div className={"col-3"}>
                            <span style={{fontWeight: "bold"}}>Ente di appartenenza</span>
                            <Input placeholder={"Ente di appartenenza"} id={"ente"}
                                   onChange={(event) => onChange(event.target.id, event.target.value)}
                                   value={state.ente ? state.ente : ""}/>
                        </div>
                    </Row>
                </div>
                <div className={"col-1"}>
                    <Button
                        id={"CercaUtente"}
                        onClick={onClickCercaUtenti}
                        typeButton={"Blue"}
                        text={"Cerca"}
                        disabled={!state.cognome || !state.nome}
                        style={{height: "45px", width: "100px", marginTop: "27px"}}
                    />
                </div>
            </Row>

            <div className="col-3">
                <Button
                    id={"modificaUtenteRicerca"}
                    typeButton={"Blue"}
                    style={{display: "none"}}
                    dataTarget={"modalModificaUtenteRicerca"}
                    dataToggle={"modal"}
                    dataBackdrop={"static"}
                    dataKeyboard={false}
                    body={modalBodyModifica}
                    header={"Modifica Utente"}
                />
            </div>

            {flagTableCercaUtenti &&
                <div>
                    <div className={" pt-2 "}>
                        <hr style={{border: "0.5px solid grey"}}/>
                    </div>
                    <p style={{fontWeight: "bold", color: "grey", fontSize: "25px"}}>Risultati</p>
                    <Table
                        cols={cols}
                        rows={rows}
                        id={"tabellaProva"}
                    />
                </div>}
        </div>
    );

}

export default RicercaUtenti;
